import React, { useMemo } from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { useMarketplaceColors } from '@/constants/residents/marketplaceColors';
import { useThemeColors } from '@/hooks/shared/useThemeColors';

const HouseIcon = RESIDENTS_SVG_COMPONENTS.HOME_PAGE;

interface BreadcrumbNavigationProps {
  onHomePress: () => void;
  onBackPress: () => void;
}

export const BreadcrumbNavigation: React.FC<BreadcrumbNavigationProps> = ({
  onHomePress,
  onBackPress,
}) => {
  const mc = useMarketplaceColors();
  const { semantic } = useThemeColors();

  // `accentBlue` resolves to the light brand blue in BOTH themes, which
  // reads at ~2.9:1 on the light page background — below the 4.5:1 AA floor
  // for these 12px labels. `text.link` is the per-theme accent: identical in
  // dark, and the darkened brand blue in light.
  const linkColor = semantic.text.link;

  const styles = useMemo(() => StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 10,
    },
    homeIconContainer: {
      width: 28,
      height: 28,
      borderRadius: 14,
      backgroundColor: mc.accentBlueBg,
      alignItems: 'center',
      justifyContent: 'center',
    },
    breadcrumbLink: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 10,
    },
    breadcrumbEllipsis: {
      fontSize: 12,
      fontWeight: '500',
      color: linkColor,
      lineHeight: 18,
    },
    breadcrumbText: {
      fontSize: 12,
      fontWeight: '500',
      color: linkColor,
      lineHeight: 18,
    },
  }), [mc, linkColor]);

  return (
    <View style={styles.container}>
      <TouchableOpacity style={styles.homeIconContainer} onPress={onHomePress}>
        <HouseIcon width={15} height={15} color={linkColor} />
      </TouchableOpacity>
      <TouchableOpacity style={styles.breadcrumbLink} onPress={onBackPress}>
        <Text style={styles.breadcrumbEllipsis}>...</Text>
        <Text style={styles.breadcrumbText}>Previous page</Text>
      </TouchableOpacity>
    </View>
  );
};
